// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstatausdc } from "../../../icons/full/build/icon-stkstatausdc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatausdcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstatausdc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatausdcIcon.displayName = 'StkstatausdcIcon';
}

export default StkstatausdcIcon;